import RightAligned from './RightAligned'

export default RightAligned
